import React from "react";
import "./work.css";
import work1 from "../../assets/solar.png";
import work2 from "../../assets/solar.png";

function Work() {
  return (
    <section className="portfolio">
      <div className="container">
        <p className="section-sub">\ Portfolio \</p>
        <h2 className="section-title">Our Work</h2>
        <div className="portfolio-grid">
          <img src={work1} alt="Work 1" />
          <img src={work2} alt="Work 2" />
        </div>
      </div>
    </section>
  );
}

export default Work;
